// extracted by mini-css-extract-plugin
module.exports = {"icon":"CurrencyPrice_icon__RiWII","load":"CurrencyPrice_load__XlWNp"};